enum GroupAge {
  None = 'NONE',
  One = 'ONE',
  Two = 'TWO',
  ThreeOrMore = 'THREE_OR_MORE',
}

export default GroupAge;
